export * from "./ICommand";
export * from "./RestfulApiService";
export const isAxiosError = (error)=>!!error.isAxiosError;
